import globalStore from 'init/global-store'
import { hostsConfig } from 'init/config'
import submissionLoader from 'widgets/submission/submission-loader'
import submissionStore, { Source } from 'store/submission-store'
import ssoService from 'services/sso-service'
import globalConfig from 'init/global.config'

export default function launchWriteReview(rawRating = undefined): void {
  const rating = typeof rawRating === 'number' ? rawRating : undefined
  // if sso, this will be set back to false when ssoRegDone or loggedInDataFnDone is called
  submissionStore.isLaunchingWriteReview = true
  if (globalConfig.ssoEnabled) {
    if (globalConfig.isPurchaseReq()) {
      ssoService.ssoCreateReview(globalStore.sku, Source.INLINE, null, rating)
    } else {
      ssoService.ssoGetLoggedInDataForReview(globalStore.sku, Source.INLINE)
    }
  } else {
    // In case the form is already open, unmount it. It will be unmounted if already mounted in
    // submissionLoader.load(), but the startRevFlow settings will be removed along with it.
    submissionLoader.unmount()
    submissionStore.startRevFlow(
      globalStore.sku,
      hostsConfig.siteKey,
      { page: 'review-form', props: {} },
      { startAction: 'review', source: Source.INLINE, starSelected: rating },
      document.activeElement as HTMLElement
    )
    submissionLoader.load()
    submissionStore.isLaunchingWriteReview = false
  }
}
